import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useMemo,
} from "react";
import { useDispatch } from "react-redux";
import { getUser } from "../../redux/actions/user";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [keycloakReady, setKeycloakReady] = useState(false);

  useEffect(() => {
    const checkToken = async () => {
      if (
        window.location.pathname === "/login" ||
        window.location.pathname === "/"
      ) {
        setKeycloakReady(true);
        return;
      }

      const token = localStorage.getItem("token");
      if (token) {
        await dispatch(getUser()).then((result) => {
          setUser(result.payload);
          setKeycloakReady(true);
        });
      } else {
        setTimeout(checkToken, 200);
      }
    };

    checkToken();
  }, [dispatch]);

  const authContextValue = useMemo(
    () => ({
      user,
      setUser,
      loading: !keycloakReady,
    }),
    [user, setUser, keycloakReady]
  );

  if (!keycloakReady) {
    return <div>Loading...</div>;
  }

  return (
    <AuthContext.Provider value={authContextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
